import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header";
import { all_routes } from "../../router/all_routes";


const route = all_routes;

const LanguageSettings = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
    localStorage.setItem("language", selectedLang); // persist selected language
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-8">
                  <h4 className="page-title">{t("languageSettings")}</h4>
                </div>
                <div className="col-4 text-end">
                  <div className="head-icons">
                    <CollapseHeader />
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Header */}

           {/* Settings Menu */}
                      <div className="card">
                        <div className="card-body pb-0 pt-2">
                        <ul className="nav nav-tabs nav-tabs-bottom">
                                <li className="nav-item me-3">
                                  <Link to={route.profile} className="nav-link px-0 active">
                                    <i className="ti ti-settings-cog" />{t("generalSettings")}
                                  </Link>
                                </li>
          
                                {/* <li  className="nav-item me-3">
                                  <Link to={route.companySettings} className='nav-link px-0'>
                                    <i className="ti ti-world-cog" /> Website Settings
                                  </Link>
                                </li>
                                <li  className="nav-item me-3">
                                  <Link to={route.invoiceSettings} className='nav-link px-0'>
                                    <i className="ti ti-apps" /> App Settings
                                  </Link>
                                </li>
                                <li  className="nav-item me-3">
                                  <Link to={route.emailSettings} className='nav-link px-0'>
                                    <i className="ti ti-device-laptop" /> System Settings
                                  </Link>
                                </li>
                                <li  className="nav-item me-3">
                                  <Link to={route.paymentGateways} className='nav-link px-0'>
                                    <i className="ti ti-moneybag" /> Financial Settings
                                  </Link>
                                </li>
                                <li  className="nav-item ">
                                  <Link to={route.storage} className='nav-link px-0'>
                                    <i className="ti ti-flag-cog" /> Other Settings
                                  </Link>
                                </li> */}
                                
                              </ul>
                        </div>
                      </div>
                      {/* /Settings Menu */}

            <div className="row">
              {/* Sidebar */}
              <div className="col-xl-3 col-lg-12 theiaStickySidebar">
                <div className="card">
                  <div className="card-body">
                    <div className="settings-sidebar">
                      <h4 className="fw-semibold mb-3">
                     {t("generalSettings")}
                      </h4>
                      <div className="list-group list-group-flush settings-sidebar">
                        {/* <Link to={route.profile} className="fw-medium">
                          {t("profile") || "Profile"}
                        </Link>
                        <Link to={route.security} className="fw-medium">
                          {t("security") || "Security"}
                        </Link> */}
                        <Link to={route.notification} className="fw-medium">
                           {t("notifications")}
                        </Link>
                        <Link
                          to={route.languageSettings}
                          className="fw-medium "
                        >
                         {t("languageSettings")}
                        </Link>
                        <Link
                          to={route.userPrivilege}
                          className="fw-medium "
                        >
                           {t("userPrivilege")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Sidebar */}

              {/* Main Content */}
              <div className="col-xl-9 col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="fw-semibold mb-3">
                     {t("preferredLanguage")}
                    </h4>
                    <div className="settings-form">
                      <div className="border-bottom mb-3 pb-3">
                        <h5 className="fw-semibold mb-1">
                         {t("selectLanguage")}
                        </h5>
                        <p className="text-muted">
                           {t("chooseYourPreferredLanguage")}
                        </p>
                      </div>

                      <div className="form-group">
                        <label htmlFor="languageSelect" className="fw-medium">
                         {t("selectLanguage")}
                        </label>
                        <select
                          id="languageSelect"
                          className="form-control"
                          value={i18n.language}
                          onChange={handleLanguageChange}
                        >
                          <option value="en">English</option>
                          <option value="ar">{t("arabic")}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Main Content */}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Account Modal (same structure for consistency, optional) */}
      <div className="modal custom-modal fade" id="delete_account" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 m-0 justify-content-end">
              <button
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="success-message text-center">
                <div className="success-popup-icon">
                  <i className="ti ti-trash-x" />
                </div>
                <h3>{t("deleteAccount") || "Delete Account"}</h3>
                <p className="del-info">
                  {t("deleteConfirmation") || "Are you sure you want to delete?"}
                </p>
                <div className="col-lg-12 text-center modal-btn">
                  <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                    {t("cancel") || "Cancel"}
                  </Link>
                  <Link to={route.security} className="btn btn-danger">
                    {t("yesDeleteIt") || "Yes, Delete it"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Account Modal */}
    </div>
  );
};

export default LanguageSettings;
